import { Path, Svg, SvgProps } from 'react-native-svg'

export default function PlFlag(props: SvgProps) {
  return (
    <Svg width="60" height="40" viewBox="0 0 60 40" fill="none" {...props}>
      <Path d="M60 0H0V20H60V0Z" fill="#ffffff" />
      <Path d="M60 20H0V40H60V20Z" fill="#DC143C" />
    </Svg>
  )
}
